import type { IconSvgObject } from './types';

const FireIcon: IconSvgObject = [
  ["path", { d: "M4.96771 10.6515C7.89633 7.16666 10.0038 5.18111 10.874 2C15.3631 4.49772 20.8942 10.8567 20.4778 15.5826C20.1445 19.3654 17.3689 21.1971 13.9894 22C13.9894 22 16.1452 19.0346 16.5481 16.7813C16.9153 13.087 14.2322 10.6672 12.9207 10.017C12.9207 10.017 13.742 13.5002 11.9162 15.5092C10.8491 12.0355 8.40044 12.0141 8.40044 12.0141C9.40493 14.5106 7.17338 15.5699 6.9285 17.2908C6.43127 20.7851 8.98142 22 8.98142 22C2.35624 19.6629 2.71904 13.0012 4.96771 10.6515Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default FireIcon;
